import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "./Menu.css";

import FooterCorp from "../modulos/footerCorp";
import obtieneDatos from "../tools/obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";

import ReempadronaCadete from "./ReempadronaCadete";
import Listado from "./Listado";
import Configuraciones from "./Configuraciones";
import Cadetes from "./Cadetes";
import CarpetaMedica from "./CarpetaMedica";
import Dashboard from "./Dashboard";
import PasesDeSalida from "./PasesDeSalida";
import Sanciona from "./sancionaa";
import Ausencia from "./Ausencias";
import LegajoForm from "./LegajoForm";
import ConsultaAsistencias from "./ConsultaAsistencias";
import ConsultaExcepciones from "./ConsultaExcepciones ";
import InformeHistoricoSanciones from "./InformeHistoricoSanciones";
import InformeRacionamiento from "./InformeRacionamiento";

const Menu = () => {
  const navigate = useNavigate();
  const Usuario = obtieneDatos();

  const [selectedComponent, setSelectedComponent] = useState("cadetes");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // ============================================================
  // CONTROL DE ACCESO
  // ============================================================

  useEffect(() => {
    if (!Usuario?.id) {
      alert("Acceso no Autorizado");
      window.location.href = "./";
    }
  }, [Usuario?.id]);

  // ============================================================
  // PERMISOS
  // ============================================================

  const tienePermiso = (permiso) => {
    return comprueboPermisos(Usuario?.funcion, permiso);
  };

  const destino = Number(Usuario?.destino);

  const esDestinoAdministrativo = [
    1,
    2,
    7,
    9,
    21,
    25,
    45,
  ].includes(destino);

  const esDestino7 = destino === 7;

  // ============================================================
  // NAVEGACIÓN
  // ============================================================

  const seleccionar = (componente) => {
    setSelectedComponent(componente);
    setIsMenuOpen(false);
  };

  // ============================================================
  // COMPONENTE ACTUAL
  // ============================================================

  const renderComponente = () => {
    switch (selectedComponent) {
      case "cadetes":
        return <Cadetes />;

      case "informes":
        return <Ausencia />;
     
      case "consultaAsistencias":
        return <ConsultaAsistencias />;
      case "consultaAvisos":
        return <ConsultaExcepciones />;
         case "consultaSanciones":
        return <InformeHistoricoSanciones />;
                 case "racionamiento":
        return <InformeRacionamiento />;
      case "reempadrona":
        return <ReempadronaCadete />;

      case "estadistica":
        return <Dashboard />;

      case "legajos":
        return <LegajoForm />;

      case "pases":
        return <PasesDeSalida />;

      case "carpetas":
        return <CarpetaMedica />;

      case "presentes":
        return <Listado />;

      case "configuraciones":
        return <Configuraciones />;

      case "sanciones":
        return <Sanciona />;

      default:
        return <Cadetes />;
    }
  };

  // ============================================================
  // ITEM
  // ============================================================

  const ItemMenu = ({
    id,
    icono,
    texto,
    volver = false,
  }) => {
    const activo = selectedComponent === id;

    return (
      <button
        type="button"
        className={`isep-cad-menu-item ${
          activo ? "isep-cad-menu-item--activo" : ""
        } ${volver ? "isep-cad-menu-item--volver" : ""}`}
        onClick={() => {
          if (volver) {
            navigate("/usuarioLogueado");
            setIsMenuOpen(false);
          } else {
            seleccionar(id);
          }
        }}
      >
        <span className="isep-cad-menu-icono">
          {icono}
        </span>

        <span className="isep-cad-menu-texto">
          {texto}
        </span>
      </button>
    );
  };

  return (
    <div className="isep-cad-layout">
      {/* ====================================================== */}
      {/* CABECERA MOBILE */}
      {/* ====================================================== */}

      <header className="isep-cad-mobile-header">
        <div className="isep-cad-brand">
          <div className="isep-cad-logo">
            ISeP
          </div>

          <div className="isep-cad-brand-info">
            <strong>Gestión de Cadetes</strong>
            <span>Sistema de administración</span>
          </div>
        </div>

        <button
          type="button"
          className="isep-cad-hamburger"
          onClick={() => setIsMenuOpen((prev) => !prev)}
        >
          ☰
        </button>
      </header>

      {/* ====================================================== */}
      {/* NAVEGACIÓN */}
      {/* ====================================================== */}

      <nav
        className={`isep-cad-nav ${
          isMenuOpen ? "isep-cad-nav--abierto" : ""
        }`}
      >
        <div className="isep-cad-nav-scroll">


          <ItemMenu
            id="cadetes"
            icono="🔎"
            texto="Cadetes"
          />
          {tienePermiso("Veo Inasistencias") && (
            <ItemMenu
              id="informes"
              icono="📋"
              texto="Informes"
            />
          )}

          <ItemMenu
            id="consultaAsistencias"
            icono="🔎"
            texto="Consulta de Asistencias"
          />
          <ItemMenu
            id="consultaAvisos"
            icono="🔎"
            texto="Consulta de Avisos"
          />
                    <ItemMenu
            id="consultaSanciones"
            icono="🔎"
            texto="Consulta de Sanciones"
          />
 {tienePermiso("racionamiento") && (
            <ItemMenu
              id="racionamiento"
              icono="🪪"
              texto="Consulta Racionamientos Cadete"
            />
          )}
          {tienePermiso("Reempadrona") && (
            <ItemMenu
              id="reempadrona"
              icono="🪪"
              texto="Reempadrona Cadete"
            />
          )}

          {esDestinoAdministrativo && (
            <>
              <ItemMenu
                id="estadistica"
                icono="📊"
                texto="Estadística"
              />

              {tienePermiso("Descargo Legajos Masivos") && (
                <ItemMenu
                  id="legajos"
                  icono="📁"
                  texto="Generar Legajos"
                />
              )}
            </>
          )}

          {esDestino7 && (
            <>
              <ItemMenu
                id="pases"
                icono="🚪"
                texto="Pases de Salida"
              />

              <ItemMenu
                id="carpetas"
                icono="🩺"
                texto="Reconocimientos Médicos"
              />

              <ItemMenu
                id="presentes"
                icono="✅"
                texto="Presentes"
              />

              <ItemMenu
                id="configuraciones"
                icono="⚙️"
                texto="Configuraciones"
              />

              <ItemMenu
                id="sanciones"
                icono="📑"
                texto="Sanciona"
              />
            </>
          )}

          <div className="isep-cad-menu-separador" />

          <ItemMenu
            id="volver"
            icono="←"
            texto="Volver"
            volver
          />

        </div>
      </nav>

      {/* ====================================================== */}
      {/* CONTENIDO */}
      {/* ====================================================== */}

      <main className="isep-cad-contenido">
        {renderComponente()}
      </main>

      {/* ====================================================== */}
      {/* FOOTER */}
      {/* ====================================================== */}

      <div className="isep-cad-footer">
        <FooterCorp />
      </div>
    </div>
  );
};

export default Menu;